<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
    />
    <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/limonte-sweetalert2/8.11.8/sweetalert2.min.css"
    />
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <div class="container-fluid ">
      <div class="row">
        <!--cambios para push-->
        <!---Enacbezado--->
        <div class="container-fluid mb-3">
          <div class="row">
            <div class="headerTitle">
              <div class="seccionTitle">
                <b-icon-credit-card2-back-fill></b-icon-credit-card2-back-fill>

                <div class="headerTxt mLeft">Corte de caja</div>
              </div>

              <div class="alignIcon bold">CJ_01_Caja</div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4"></div>
          </div>

          <div>
            <b-row v-if="$localStorageService.can('FC_fecha_corteCaja')" class="pt-3 pb-3">
              <b-col cols="4">
                <b-form-datepicker v-model="fechaBuscar" placeholder="Fecha" :max="fechaMaxima"
                                   no-flip
                                   :state="fechaBuscar != null"
                                   @input="fechaSeleccionadaClick($event)">
                </b-form-datepicker>
              </b-col>
              <b-col class="text-left">
                <b-button @click="buscarCorte()" :disabled="loader" variant="outline-primary">
                  <span v-if="!loader">Buscar</span>
                  <span v-if="loader">
                        <b-spinner small></b-spinner>
                    Buscando...
                    </span>
                </b-button>
              </b-col>
              <b-col class="text-right" v-if="$localStorageService.can('CC_exportar_corte_caja')">
                <download-excel
                    v-if="cortecaja.length > 0"
                    class="btn btn-primary"
                    :data="cortecaja"
                    :fields="fieldsExcel"

                    worksheet="My Worksheet"
                    :name="'Corte'+$formatoFecha(new Date())+'.xls'"
                >
                  Generar Excel
                  <em class="fa fa-file-excel-o"></em>
                </download-excel>
              </b-col>
            </b-row>
            <div class="row">
              <div class="col-md-12">
                <b-table
                    id="corte"
                    style="font-size: 12px !important;"
                    thead-tr-class="columnas"
                    :fields="columnasCorte"
                    :items="cortecaja"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    responsive="true"
                    class="parrafos"
                >
                  <template v-slot:cell(fecgaPago)="row">
                    {{ row.item.fechaPago | formatoHora }}
                  </template>
                  <template v-slot:cell(importe)="row">
                    <span v-if="row.item.idTratamientoProgramado !== null">{{ row.item.importe | moneda }} </span>
                    <span v-else>{{ row.item.importe | monedaDecimales }} </span>
                  </template>
                  <template v-slot:cell(forma)="row">
                    {{ row.item.forma }}
                    <b-badge v-if="row.item.aprobado === false" variant="danger"> no aprobado</b-badge>
                    <b-badge v-if="row.item.aprobado === null" variant="warning"> en aprobación</b-badge>
                  </template>
                  <template v-slot:cell(totalSesion)="row">
                    {{ row.item.totalSesion | moneda }}
                  </template>
                  <template v-slot:cell(descuento)="row">
                    <span v-if="row.item.idTratamientoProgramado !== null"> {{ row.item.idPacienteVale == null ? row.item.descuento + '%' : '0%' }} </span>
                    <span v-else>N/A</span>
                  </template>
                  <template v-slot:cell(montoVale)="row">
                   <span v-if="row.item.idTratamientoProgramado !== null"> {{ row.item.idPacienteVale != null ?  '$'+row.item.montoVale : '$0' }} </span>
                   <span v-else> N/A </span>
                  </template>
                  <template v-slot:cell(descPromo)="row">
                   <span v-if="row.item.idTratamientoProgramado !== null"> {{ row.item.descPromo != null ?  '$'+row.item.descPromo : '$0' }} </span>
                   <span v-else> N/A </span>
                  </template>
                  <template v-slot:cell(descCupon)="row">
                    <span v-if="row.item.idTratamientoProgramado !== null"> {{ row.item.descCupon != null ?  '$'+row.item.descCupon : '$0' }} </span>
                    <span v-else> N/A </span>
                  </template>
                  <template v-slot:cell(totalTx)="row">
                   <span v-if="row.item.idTratamientoProgramado !== null"> {{ row.item.totalTx | moneda }} </span>
                   <span v-else> {{ row.item.totalTx | monedaDecimales }} </span>
                  </template>
                  <template v-slot:cell(adeudo)="row">
                    {{ row.item.adeudo | moneda }}
                  </template>
                  <template v-slot:cell(iva)="row">
                    {{ row.item.iva | monedaDecimales }}
                  </template>
<!--                  <template v-slot:cell(Totaltx)="row">
                    {{ row.item.totalTx | monedaDecimales }}
                  </template>-->
                </b-table>
                <b-col v-if="loader">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </b-col>
                <b-col v-if="!loader && cortecaja.length === 0">
                  <b-alert v-if="cortecaja.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
                <b-col v-if="!loader">
                  <b-pagination
                      v-if="cortecaja !== undefined && cortecaja.length > 10"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="cortecaja.length"
                      :per-page="registrosPorPagina"
                      aria-controls="my-table1"
                  ></b-pagination>
                </b-col>
              </div>
            </div>
            <!--Tabla--->
            <div class="row">
              <div class="col-md-4">
                <div class="headerTitle">
                  <div class="seccionTitle">
                    <div class="headerTxt mLeft">Resumen de Pagos</div>

                  </div>

                </div>
                <b-table
                    id="resumen"
                    thead-tr-class="columnas"
                    :fields="columnasTotales"
                    :items="totales"
                    :align="'left'"
                    responsive="true"
                    class="parrafos"
                >

                  <template v-slot:cell(Total)="row">
                    <span v-if="row.item.nombreForma === 'ADEUDO' && row.item.total > 0"  style="color: red;">{{ row.item.total | moneda }}</span>
                    <span v-else-if="row.item.nombreForma === 'TDC' && row.item.total > 0 " >{{ row.item.total | monedaDecimales }}</span>
                    <span v-else >{{ row.item.total | moneda }}</span>
                  </template>
                </b-table>
                <b-table
                    id="resumen"
                    :fields="columnasNoIngresos"
                    :items="noIngresos"
                    :align="'left'"
                    responsive="true"
                    class="parrafos"
                >
                  <template #thead-top="data">
                    <b-tr>
                      <b-th variant="secondary"  colspan="2">
                        Otros
                      </b-th>
                    </b-tr>
                  </template>
                  <template v-slot:cell(Total)="row">
                    <span>{{ row.item.total | moneda }}</span>
                  </template>
                </b-table>
              </div>
              <div class="col-md-4">
                <div class="headerTitle">
                  <div class="seccionTitle">
                    <div class="headerTxt mLeft">Factura Global</div>
                  </div>
                </div>
                <b-table-simple responsive>
                  <b-tbody>
                    <b-tr>
                      <b-td class="text-left">Facturas Px</b-td>
                      <b-td>{{ totalFacturasPx }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-td class="text-left">Cantidad facturado</b-td>
                      <b-td>{{ cantidadFacturasPx | moneda }}</b-td>
                    </b-tr>
                    <b-tr variant="primary" class="bold">
                      <b-td class="text-left">Total factura global</b-td>
                      <b-td>{{ totalFacturaGlobal | moneda }}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
                <b-button
                    v-if="idFacturaGlobal === null && totalFacturaGlobal > 0 && existeCorteHoy && $localStorageService.can('BT_facturar')"
                    :disabled="loaderFacturacion"
                    variant="outline-primary" @click="facturar()">
                  <span v-if="!loaderFacturacion">Facturar</span>
                  <span v-if="loaderFacturacion"><b-spinner small></b-spinner>Facturando...</span>
                </b-button>
                <b-button v-if="idFacturaGlobal !== null" :disabled="loaderImpresion" variant="outline-primary"
                          @click="imprimirFactura()">
                  <span v-if="!loaderImpresion">Imprimir</span>
                  <span v-if="loaderImpresion"><b-spinner small></b-spinner>Imprimiento...</span>
                </b-button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">

              </div>
              <div class="col-md-4">
                <b-badge style="font-size: large; background: #0e6ba9" variant="info"><p><strong>Total de
                  ingresos:</strong>
                  {{ totalIngresos | moneda }}</p></b-badge>

              </div>
            </div>

            <div class="row" v-if="!existeCorteHoy">
              <div class="col-md-4 col-sm-12 ml-auto">
                <div class="row">
                  <div class="col-12">
                    <b-form-group label="¿Cuadró el corte?" v-slot="{ ariaDescribedby }">
                      <b-form-radio v-model="guardado.cuadre" :aria-describedby="ariaDescribedby"
                                    name="some-radios" value="1">Si
                      </b-form-radio>
                      <b-form-radio v-model="guardado.cuadre" :aria-describedby="ariaDescribedby"
                                    name="some-radios" value="0">No
                      </b-form-radio>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <b-form-textarea
                        id="textarea"
                        v-model="guardado.descripcion"
                        placeholder="Descripción del corte de caja"
                        rows="3"
                        max-rows="6"
                    ></b-form-textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="text-right mt-3 col-12">
                    <b-button v-if="$localStorageService.can('BT_Cortedecaja_guardar')" :disabled="loaderGuardar" variant="outline-primary" @click="validarSesionesCerradas()">
                      <span v-if="!loaderGuardar">Guardar</span>
                      <span v-else><b-spinner small></b-spinner>Guardando...</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="existeCorteHoy" class="mt-5 mb-5">
              <b-alert variant="warning" show>Ya se realizó este corte de caja</b-alert>
            </div>
          </div>

        </div>
      </div>

    </div>


    <b-modal
        v-model="show"
        title="Detalle del pago"
        size="lg"
    >
      <b-container fluid>
        <b-row>
          <b-col>

            <b-table
                id="paguitos"
                thead-tr-class="columnas"
                :fields="fields"
                :items="datosPagos"
                responsive="true"
                class="text-left"
            >
              <template v-slot:cell(Monto)="row">
                {{ row.item.monto | moneda }}
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">

        <b-button variant="outline-danger" @click="cerrarModal()">Cerrar</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import * as JSZip from "jszip";
import {saveAs} from 'file-saver'

export default {
  name: "corteCaja",
  components: {
    Header,
  },

  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      //hettamoentas de diagnostico
      show: false,
      cortecaja: [],
      fields: [{key: "metodoPago", label: "Metodo de pago", tdClass: 'text-left'},
        "Monto",
        {key: "msi", label: "Meses sin intereses"}],
      columnasCorte: [
        {key: "recibo", label: "Recibo", sortable: true},
        {key: "factura", label: "Factura", sortable: true},
        {key: "idPaciente", label: "ID PX", sortable: true},
        {key: "paciente", label: "Paciente", sortable: true},
        {key: "rfc", label: "RFC", sortable: true},
        {key: "numeroSesion", label: "Sesión", sortable: true},
        {key: "tratamiento", label: "Concepto", sortable: true},
        {key: "totalSesion", label: "Precio unitario", sortable: true},
        {key: "descuento", label: "Descuento plan", sortable: true},
        {key: "montoVale", label: "Descuento vale", sortable: true},
        {key: "descPromo", label: "Descuento Promo", sortable: true},
        {key: "descCupon", label: "Descuento Cupón", sortable: true},
        {key: "iva", label: "IVA", sortable: true},
        {key: "totalTx", label: "Total", sortable: true},
        {key: 'importe', label: "Cobrado", sortable: true, tdClass:'backgroundTd'},
        {key: 'adeudo', label: "Adeudo", sortable: true},
        {key: "forma", label: "Forma de pago", sortable: true},
        {key: "fecgaPago", label: "Hora del pago", sortable: true},
        {key: "tipo", label: "Tipo de pago", sortable: true}

      ],
      columnasTotales: [{key: "nombreForma", label: "Metodo de pago", tdClass: 'text-left'},
        "Total"],
      columnasNoIngresos: [{key: "nombreForma", label: "Concepto", tdClass: 'text-left'},
        "Total"],
      fieldsExcel: {
        "Recibo": "recibo",
        "Factura": "factura",
        "ID PX": "idPaciente",
        "Paciente": "paciente",
        "RFC": "rfc",
        "Sesion": "numeroSesion",
        "ID tratamiento programado": "idTratamientoProgramado",
        "Tratamiento": "tratamiento",
        "Total Sesión": "totalSesion",
        "Descuento": "descuento",
        "Total tx": "totalTx",
        "Cobrado": "importe",
        "Adeudo": "adeudo",
        "Forma de pago": "forma",
        "Hora del pago": "fecgaPago",
        "Tipo de pago": "tipo"
      },
      loader: false,
      paginaActual: 0,
      registrosPorPagina: 10,
      totalIngresos: null,
      totalFacturasPx: null,
      cantidadFacturasPx: null,
      totalFacturaGlobal: null,
      guardado: {
        cuadre: 1,
        descripcion: null
      },
      idClinica: null,
      totales: [],
      noIngresos: [],
      datosPagos: [],
      idFacturaGlobal: null,
      loaderFacturacion: false,
      loaderImpresion: false,
      existeCorteHoy: false,
      loaderGuardar: false,
      intervalo:null,
      fechaBuscar: null,
      fechaMaxima: null,
      loading:false
    };
  },
  async created() {
    await this.obtenerFechaReal();
    this.debug = this.$localStorageService.getDebug();
    this.idClinica = this.$localStorageService.getIdClinica();
    await this.buscarCorte();
  },
  methods: {

    /**
     *  Metodo que manda a llamar el servicio "diagnostico/obtener/CorteCaja" el cual obtiene los datos que se mostraran en la vista
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    async buscarCorte() {
      this.loader = true;
      this.verificarCorte()

      const parametros = {
        idClinica: this.idClinica,
        fechaInicio: this.fechaBuscar.split("T")[0]
      }
     await this.$http
          .post(this.$api + "diagnostico/obtener/CorteCaja", parametros)
          .then((response) => {
            if (response.data.data) {
              this.cortecaja = response.data.data.datosTabla;
              this.totales = response.data.data.totales;
              this.noIngresos = response.data.data.noIngresos;
              this.totalIngresos = response.data.data.totalIngresos;
              this.totalFacturasPx = response.data.data.totalFacturasPx;
              this.cantidadFacturasPx = response.data.data.cantidadFacturaPX;
              this.totalFacturaGlobal = response.data.data.totalFacturaGlobal;
            }
          }).finally(() => {
        this.loader = false;
      });

    },
    enviodePagoRecibo() {
      this.listaPagos.map((pago) => {
        pago.idFormaPago = pago.formaPago.id;
        pago.idCuenta = 1;
      });

      let miObjetoParaPost = {
        aplicarSaldo: this.aplicarSaldo,
        formaPagos: this.listaPagos,
        idSesion: 20891389,
        totalPagar: this.totalTratamientos,
        tratamientos: this.tratamientossesion,
        usuarioLog: this.$localStorageService.getIdUsuario(),
      };

      this.$http
          .post(
              this.$api + "diagnostico/guardar/pago/tratamientoSesion",
              miObjetoParaPost
          )
          .then(() => {
          });
    },

    verDetalle(item) {
      this.datosPagos = item;
      this.show = true;
    },

    cerrarModal() {
      this.show = false;
    },
    /**
     *  Metodo que manda a llamar el servicio de facturacion
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    facturar() {
      if (this.totalFacturaGlobal >0) {
        this.loaderFacturacion = true;

        const envio = {
          idRecibo: null,
          idDatosFiscales: null,
          cfdi: "P01",
          idClinica: this.$localStorageService.getIdClinica(),
          fecha: this.fechaBuscar.split("T")[0],
          fechaFin: null,
          cantidadGlobal: this.totalFacturaGlobal
        };
        this.$http.post(this.$api + 'facturacion/facturaGlobal', envio).then(respuesta => {
          if (respuesta.data.data) {
            if (respuesta.data.data.includes('exito')) {
              const mensaje = respuesta.data.data;
              const array = mensaje.split("|");
              this.idFacturaGlobal = array[1];


              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Se generó la factura correctamente",
              });
              this.showModalFactura = false;
              this.obtenerRecibos();
              this.obtenerFacturas();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: respuesta.data.data,
              });
              this.obtenerFacturas();
            }
          }
        }).finally(() => {
          this.loaderFacturacion = false;
        })
      }
    },
    imprimirFactura() {
      this.loaderImpresion = true;
      const parametros = {idFactura: this.idFacturaGlobal}
      this.$http
          .post(this.$api + "reportes/factura/erp", parametros)
          .then((respuesta) => {
            if (respuesta.data.data === null ){
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: 'No se encontro la url de la factura',
              });
              return false
            }else {
              window.open(respuesta.data.data);
            }
            // const datos = respuesta.data.data;
            // this.descargarFactura(datos);
          }).finally(() => {
        this.loaderImpresion = false
      })
    },
    descargarFactura(datos){
      const pdf =datos.pdf;
      const xml =datos.xml;
      const folio =datos.uid;
      const zip = new JSZip();
      zip.file(folio+".xml", xml, {base64: false});
      zip.file(folio+".pdf", pdf, {base64: true});
      zip.generateAsync({type:"blob"})
          .then(function(content) {
            saveAs(content, folio+".zip");
          });
    },

    descargar(nombre, datos) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: 'application/pdf'});

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre;
      link.click();
    },

    /**
     *  Metodo que manda a llamar el servicio "sesion/cerradas" el cual sirve ara validar que las sesiones estan cerradas de los recibos que se realiaran el corte de caja
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    validarSesionesCerradas() {
      this.loaderGuardar = true

      const params = {
        idClinica: this.$localStorageService.getIdClinica(),
        fecha: this.fechaBuscar.split("T")[0]
      }
      const url = this.$api + "sesion/cerradas";
      this.$http.post(url, params)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data === true) {
                this.guardarCorte();
              } else {
                this.loaderGuardar = false
                this.$swal({
                  icon: "warning",
                  text: "No se pudo realizar el corte de caja ya que aun cuentas con sesiones activas",
                  confirmButtonText: "OK",
                  confirmButtonColor: "#0e6ba9",
                });
              }
            }
          })
    },

    /**
     *  Metodo que manda a llamar el servicio de guardado para el corte de caja
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    guardarCorte() {
      this.loaderGuardar = true;
      const envio = {
        idClinica: this.idClinica,
        total: this.totalIngresos,
        comentario: this.guardado.descripcion !== null ? this.guardado.descripcion : 'Sin comentarios',
        fecha: this.fechaBuscar.split("T")[0]
      }
      this.$http
          .post(this.$api + "diagnostico/guardar/CorteCaja", envio)
          .then((response) => {
            if (response.data.data) {
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "Corte de caja guardado correctamente",
              });
              this.facturar();
              this.verificarCorte();
            }
          }).finally(() => {this.loaderGuardar = false});
    },

    /**
     *  Metodo que obtiene la verificacion si existe corte de caja
     *
     *  La fecha se envia en "crudo" esto significa que la fecha enviada al back es el dato tal cual lo recibe del datepicker sin modificaciones
     *  El back se encargara del formato
     */
    verificarCorte() {

      const parametros = {
        idClinica: this.idClinica,
        fechaInicio: this.fechaBuscar.split("T")[0]
      }
      this.$http
          .post(this.$api + "diagnostico/existe/CorteCaja", parametros)
          .then((response) => {
            this.existeCorteHoy = response.data.data.existe;
            this.idFacturaGlobal = response.data.data.idFactura
            if(this.existeCorteHoy){
           this.intervalo = setInterval(() => {
                this.exit();
              },1800000);
            }

          })
    },
    exit() {
      this.loading = true;
      this.$session.destroy();
      this.$router.push({
        name: "login"
      });
      this.$localStorageService.removeMenus();
      this.$localStorageService.removePostales();
      clearInterval(this.intervalo)
    },
    /**
     * Método que se ejecuta cuando se selecciona una fecha en el datepicker
     * Actualiza el valor de la fecha de búsqueda limpiando primero el valor anterior
     * @param event - Fecha seleccionada del datepicker
     */
    fechaSeleccionadaClick(event) {
      this.fechaBuscar = null;
      this.fechaBuscar = new Date(event).toISOString();
    },
    /**
     * Obtiene la fecha actual del servidor para establecer la fecha máxima permitida
     * y la fecha de búsqueda inicial del corte de caja
     * @returns {Promise<void>} Promesa que se resuelve cuando se obtiene la fecha del servidor
     */
    async obtenerFechaReal() {
      await this.$http
          .get(this.$api + "diagnostico/fechaActual/CorteCaja")
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.fechaMaxima = new Date(respuesta.data.data).toISOString();
              this.fechaBuscar = this.fechaMaxima;

            }
          });
    },

  },

  mounted() {
  },
};
</script>

<style>

</style>
